import { useCallback, useContext, useState } from 'react';
import Drawer from 'components/gruenland/atoms/drawer/Drawer';
import CountryFlag from 'components/gruenland/atoms/localization/CountryFlag';
import Typography from 'components/gruenland/atoms/typography';
import { Close } from 'components/gruenland/icons/Close';
import LanguagePicker from 'components/gruenland/molecules/localization/LanguagePicker';
import MarketPicker from 'components/gruenland/molecules/localization/MarketPicker';
import { MarketContext } from 'context/market';
import useCountry from 'helpers/hooks/useCountry';
import { useFormat } from 'helpers/hooks/useFormat';
import useLanguage from 'helpers/hooks/useLanguage';
import { LANGUAGE_NAMES } from 'project.config';

export type Market = {
  region: string;
  countryCode: string;
  currency: string;
  currencyCode: string;
};

const MarketButton = () => {
  const [showMarket, setShowMarket] = useState(false);
  const { market: selectedMarket } = useContext(MarketContext);

  const { formatMessage } = useFormat({ name: 'gruenland' });

  const showMarketMenu = () => {
    setShowMarket(true);
  };

  const hideMarketMenu = () => {
    setShowMarket(false);
  };

  const [language, setLanguage] = useLanguage();
  const [country] = useCountry();

  const onSelectLanguage = useCallback((language: string) => setLanguage(language), [setLanguage]);

  return (
    <>
      {selectedMarket && (
        <button className="flex items-center gap-3" onClick={showMarketMenu}>
          {country.visible && <CountryFlag countryCode={selectedMarket.countryCode} />}
          <p>
            {selectedMarket?.region} / {LANGUAGE_NAMES[language.slice(0, 2)]}
          </p>
        </button>
      )}

      <Drawer isOpen={showMarket} direction="right" className="w-[90%] max-w-[380px]" onClose={hideMarketMenu}>
        <div className="flex w-full items-center justify-between border-b px-4 py-5">
          <button onClick={hideMarketMenu}>
            <Close />
          </button>
        </div>

        <div className="border-b border-neutral-400 px-4 py-5">
          <Typography as="h5" className="mb-[10px] text-[20px] text-neutrals-black">
            {formatMessage({ id: 'i18n.selectLanguage', defaultMessage: 'Seleziona la lingua' })}
          </Typography>
          <LanguagePicker currentLanguage={language} onSelectLanguage={onSelectLanguage} />
        </div>

        <div className="border-b border-neutral-400 px-4 py-5">
          <Typography as="h5" className="mb-[10px] text-[20px] text-primary-black">
            {formatMessage({ id: 'i18n.selectCoutry', defaultMessage: 'Seleziona il paese' })}
          </Typography>
          <MarketPicker />
        </div>
      </Drawer>
    </>
  );
};
export default MarketButton;
